import { useMemo } from 'react';

import { useSolveMetricsQueryParams } from './useSolveMetricsQueryParams';
import keyBy from 'lodash/fp/keyBy';
import { useGetWidgetBreakdownMetricsQuery } from 'src/services/workflow-builder-metrics';
import { BreakdownData, ChannelMode } from 'src/types/workflowBuilderAPITypes';

export function useWidgetMetricBreakdownById(
  tags?: string[],
  options?: { skip?: boolean },
) {
  const { channel, from, headerChannel, to } = useSolveMetricsQueryParams();
  const channel_mode: ChannelMode | undefined =
    channel === 'voice'
      ? headerChannel === 'outbound'
        ? 'outbound'
        : 'inbound'
      : channel === 'web_call'
        ? 'inbound_web_call'
        : undefined;

  const { data, isFetching } = useGetWidgetBreakdownMetricsQuery(
    {
      channel,
      channel_mode,
      from,
      tags: tags?.length ? tags : undefined,
      to,
    },
    { skip: options?.skip },
  );

  return useMemo(() => {
    const breakdownById = keyBy<BreakdownData>('id')(data?.breakdown);

    return { breakdownById, isFetching };
  }, [data, isFetching]);
}
